'use client'

import dynamic from 'next/dynamic'
import { useProductCardConsumerLayoutContext } from 'product-card/hooks/useProductCardConsumerLayoutContext'
import {
	type ProductCardBaseProps,
	ProductCardVariant,
} from 'product-card/types'
import type { ReactNode } from 'react'

const ProductCard = dynamic(() =>
	import('product-card/components/ProductCard/ProductCard').then(
		(mod) => mod.ProductCard
	)
)
const OverviewProductCard = dynamic(() =>
	import(
		'product-card/components/OverviewProductCard/OverviewProductCard'
	).then((mod) => mod.OverviewProductCard)
)

export const ProductCardDispatcher = ({
	className,
}: ProductCardBaseProps): ReactNode => {
	const { variant } = useProductCardConsumerLayoutContext()

	if (variant === ProductCardVariant.General) {
		return <ProductCard className={className} />
	}

	if (variant === ProductCardVariant.Overview) {
		return <OverviewProductCard className={className} />
	}

	throw new Error(`Unknown ProductCard variant: ${variant}.`)
}
